(function () {
    'use strict';
    a3_cabin_reports.factory('AnnualLeavesFactory', AnnualLeavesFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name AnnualLeavesFactory
     * @description 
     *    Get Annual Leaves Data 
     * @ngInject
     */
    function AnnualLeavesFactory(GenericService) {

        /**
         * Initialize the AnnualLeaves
         * @memberof CheckInFactory
         */
        function AnnualLeaves() {

        }

        var objType = 'AnnualLeaves';
        var objCallback = AnnualLeaves;

        var service = {
            setAnnualLeavesToStorage: setAnnualLeavesToStorage,
            getAnnualLeavesToStorage: getAnnualLeavesToStorage
        }
    
        /**
        * Save Annual Leaves
        * @param {array} annualLeavesInInfo 
        */
        function setAnnualLeavesToStorage(annualLeavesInInfo) {
            if (annualLeavesInInfo == undefined || annualLeavesInInfo == null) {
                GenericService.removeAll(objType);
            }
            else {             
                GenericService.saveAll(annualLeavesInInfo, objType, objCallback);
            }
        }

        /**
         * Get annual leaves from localStorage (populated by calendar sync).
         * @returns {array} list of AnnualLeave objects { Date, Type, DutyDescription }
         */
        function getAnnualLeavesToStorage() {
            return GenericService.list(objType, objCallback);
        }

        return service;
        
    }

})();